'use strict';

var randomNumber = require('random-number');

var randomNumberGenerator = randomNumber.generator({
	min: 1000000,
	max: 9999999,
	integer: true
});

module.exports = {
	randomNumber: randomNumberGenerator
};


//////////////////
// WEBPACK FOOTER
// ./~/protoo-client/lib-es5/utils.js
// module id = 691
// module chunks = 0